import { compareDesc } from 'date-fns';

import {
    CoachingRole,
    InteractionSummaryDto,
    ObservationSummaryDto,
} from '../../coaching-base/general';

import {
    ObservationSummaryContainerView,
    ObservationSummaryView,
} from './observation-summary.model';

export function observationSummaryToViewTransformer(
    items: ObservationSummaryDto[],
): ObservationSummaryView[] {
    const result: { [identifier: string]: ObservationSummaryView } = {};

    (items || ([] as ObservationSummaryDto[]))
        .sort((a, b) => {
            return compareDesc(
                new Date(a.event.updatedOn || a.event.createdOn),
                new Date(b.event.updatedOn || b.event.createdOn),
            );
        })
        .forEach((item) => {
            let focusContainers = item.focusContainers;

            /* because of certain requirements, ObservationComponent will show the unfocused container when there are no focused containers.
             * this works out for some published migrated observations from the old coaching model which seem to have a single unfocused container */
            const mixedFocusUnfocused =
                item.focusContainers.filter((e) => e.behaviourId == null)
                    .length !== item.focusContainers.length;
            if (item.event.published && mixedFocusUnfocused) {
                focusContainers = item.focusContainers.filter(
                    (e) => e.behaviourId != null,
                );
            }

            const performer = item.eventParticipants.find(
                (ee) => ee.coachingRoleId === CoachingRole.PERFORMER,
            );

            focusContainers.forEach((fc) => {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                const identifier = `${fc.behaviourId}-${fc.subBehaviourId}-${item.event.published}`;
                if (result[identifier] == null) {
                    result[identifier] = {
                        behaviour: fc.behaviourFullName,
                        subBehaviour: fc.subBehaviourFullName,
                        published: item.event.published,
                        obsIdentifier: `${fc.behaviourId}-${fc.subBehaviourId}`,
                        focusContainers: [],
                    };
                }

                const interactions =
                    fc.interactions || ([] as InteractionSummaryDto[]);

                const notesCount = interactions.reduce((pp, cc) => {
                    if (cc.notes) {
                        pp += cc.notes.length;
                    }
                    return pp;
                }, 0);

                const next: ObservationSummaryContainerView = {
                    observationId: item.event.eventId,
                    published: item.event.published,
                    performerId: performer ? performer.userId : null,
                    behaviourId: fc.behaviourId,
                    subBehaviourId: fc.subBehaviourId,
                    numInteractions: interactions.length,
                    numNotes: notesCount,
                    date: item.event.updatedOn || item.event.createdOn,
                    opportunityToDemonstrate: fc.score
                        ? fc.score.opportunityToDemonstrate
                        : null,
                    willingnessToTry: fc.score
                        ? fc.score.willingnessToTry
                        : null,
                    proficiencyDelivered: fc.score
                        ? fc.score.proficiencyDelivered
                        : null,
                    metrics: fc.metrics
                        ? fc.metrics.map((e) => e.metricId)
                        : [],
                };

                result[identifier].focusContainers.push(next);
            });
        });

    return Object.values(result);
}
